module.exports = __webpack_public_path__ + "img/7ea76fb0-b39f-440b-a7c2-6e7d16225782.afc15f9d.webp";